/* eslint-disable func-style */
import React, {Component, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {uniq} from 'lodash';
import parse from 'html-react-parser';
import {getSizedImageUrl} from '@shopify/theme-images';
import 'custom-event-polyfill';

function AddToCart({disabled, text, addToCart}) {
  return (
    <button
      type="submit"
      className="btn btn--primary-alt btn--add-to-cart btn--block"
      name="addtocart"
      id="AddToCart"
      disabled={disabled}
      onClick={(evt) => addToCart(evt)}
    >
      {text}
    </button>
  );
}

function FindStockistLink({isShown, text, link}) {
  return (
    <a href={link} className="btn btn--primary-alt">
      {text}
    </a>
  );
}

function handleize(str) {
  str = str.toLowerCase();
  var toReplace = ['"', "'", '\\', '(', ')', '[', ']'];
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], '');
  }
  str = str.replace(/\W+/g, '-');
  if (str.charAt(str.length - 1) == '-') {
    str = str.replace(/-+\z/, '');
  }
  if (str.charAt(0) == '-') {
    str = str.replace(/\A-+/, '');
  }
  return str;
}

function RadioGroup({option, selectedValue, updateOption, position}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownOptionSelectedLabel, setDropdownOptionSelectedLabel] = useState('initial');

  useEffect(() => {
    const checked = document.querySelector(`.radio-input[name="${option.name}"]:checked`);
    const label = checked?.closest('.radio__group')?.querySelector('label');
    setDropdownOptionSelectedLabel(label?.innerHTML ?? 'Select');
  }, [selectedValue]);

  const uniqValues = uniq(option.values);
  const options = uniqValues.map((value) => ({
    value: value.name,
    label: value.name,
    isDisabled: value.isDisabled,
  }));

  const dropdownOptions = ['colour', 'color', 'size'];
  const isDropdown = () => dropdownOptions.includes(option.name.toLowerCase()) && option.values?.length > 2;
  const optionsStyle = () => window.theme.productPage.productOptionsStyle;
  const showInput = () => !isDropdown() && (optionsStyle() === 'round-options' || optionsStyle() === 'square-options');

  const iconDropdown = () => {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 5.32562L3.27778 5L8 8.60012L12.7222 5L13 5.32562C12.0298 6.53984 9.8724 8.93874 8.73479 10.193C8.3406 10.6276 7.65939 10.6278 7.26513 10.1932C6.12976 8.94182 3.97821 6.54982 3 5.32562Z" fill="black"/>
      </svg>
    );
  };

  const iconClose = () => {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" fill="white"/>
        <path d="M4.23438 4.80006L11.2001 11.7657L11.7657 11.2001L4.80006 4.23438L4.23438 4.80006Z" fill="black"/>
        <path d="M11.7656 4.80006L4.79994 11.7657L4.23425 11.2001L11.1999 4.23438L11.7656 4.80006Z" fill="black"/>
      </svg>
    );
  };

  const iconTick = () => {
    return (
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M6 9.5c-.3-.3-.7-.3-1 0-.3.3-.3.7 0 1l3.7 3.4L15 7.5c.3-.3.3-.7 0-1s-.7-.3-1 0L8.6 12 6 9.5z" fill="currentColor"/></svg>
    );
  }

  const openDropdown = () => {
    setShowDropdown(true);
    document.querySelector('body').classList.add('dropdown-open');
  };

  const closeDropdown = (event) => {
    event.stopPropagation();
    setShowDropdown(false);
    document.querySelector('body').classList.remove('dropdown-open');
  };

  const renderRadioOptions = () => {
    return (
      options.map((opt, index) => {
        let color = '';
        if (
          option.name.toLowerCase() === 'colour' ||
          option.name.toLowerCase() === 'color'
        ) {
          color = window.theme.swatches[opt.value];
        }
        const uniqInput = handleize(option.name + index + Math.floor(Math.random() * 90000) + 10000);
        return (
          <div key={index} className={`radio__group ${opt.isDisabled ? 'disabled' : ''} ${selectedValue === opt.value ? 'is-checked' : ''}`}>
            <input
              className={`radio-input${ showInput() ? '' : ' hide'}`}
              type="radio"
              name={option.name}
              id={uniqInput}
              value={opt.value}
              checked={selectedValue === opt.value}
              onChange={(evt) => updateOption(evt.target.value, position)}
            />
            <label
              htmlFor={uniqInput}
              className={opt.isDisabled ? 'disabled' : ''}
            >
              <span className="radio-input__status hide">{iconTick()}</span>
              {color && color !== '' && (
                <div className="variant__color--swatch" style={{backgroundColor: color}}></div>
              )}
              <span>{opt.label}</span>
            </label>
          </div>
        );
      })
    );
  };

  const handleDropdownOptionClicked = (event) => {
    const ele = event.currentTarget;
    if (ele.classList.contains('disabled')) {
      closeDropdown();
      return;
    }

    closeDropdown(event);
    selectedValue = ele.dataset.value;
    updateOption(selectedValue, position);
  };

  const renderDropdownOptions = () => {
    return (
      options.map((opt, index) => {
        let color = '';
        if (
          option.name.toLowerCase() === 'colour' ||
          option.name.toLowerCase() === 'color'
        ) {
          color = window.theme.swatches[opt.value];
        }
        const uniqInput = handleize(option.name + index + Math.floor(Math.random() * 90000) + 10000);
        return (
          <div key={index} className={`radio__group ${opt.isDisabled ? 'disabled' : ''}`} data-value={opt.value} onClick={(event) => handleDropdownOptionClicked(event)}>
            <input
              className={`radio-input${ showInput() ? '' : ' hide'}`}
              type="radio"
              name={option.name}
              id={uniqInput}
              value={opt.value}
              checked={selectedValue === opt.value}
              onChange={(evt) => updateOption(evt.target.value, position)}
            />
            <label
              htmlFor={uniqInput}
              className={opt.isDisabled ? 'disabled' : ''}
            >
              {color && color !== '' && (
                <div className="variant__color--swatch" style={{backgroundColor: color}}></div>
              )}
              <span>{opt.label}</span>
            </label>
          </div>
        );
      })
    );
  };

  return (
    <React.Fragment>
      <div className={`form__group form__group--${option.name.toLowerCase()} ${option.name.toLowerCase() === 'color' || option.name.toLowerCase() === 'colour' ? '' : 'form__group--common'} ${isDropdown() ? 'is-dropdown' : ''} ${optionsStyle()}`}>
        <label>{option.name}</label>
        {isDropdown()
        ? (
          <>
            <div className={`dropdown-select--container${showDropdown ? ' dropdown-open' : ''}`} onClick={openDropdown}>
              <div className="dropdown-select--label">
                <div className="dropdown-select--selected-label" dangerouslySetInnerHTML={{__html: dropdownOptionSelectedLabel}}/>
                <div className="dropdown-select--icon">
                  {iconDropdown()}
                </div>
              </div>
              <div className={`dropdown-select--modal ${showDropdown ? '' : 'hide'}`}>
                <div className="dropdown-select--overlay" onClick={closeDropdown} />
                <div className="dropdown-select--options-container">
                  <div className="dropdown-select--option-name">
                    {option.name}
                    <div className="dropdown-select--icon" onClick={closeDropdown} >
                      {iconClose()}
                    </div>
                  </div>
                  <div className="dropdown-select--options" onClick={closeDropdown}>
                    {renderDropdownOptions()}
                  </div>
                </div>
              </div>
              </div>
          </>
        )
        : (
          <>
            <div className="form__group--inner">
              {renderRadioOptions()}
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
}

export default class ProductForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVariantId: 0,
      selectedVariantSKU: '',
      selectedVariantImg: '',
      selectedVariant: {},
      selectedOptions: [],
      buttonText: 'Add To Cart',
      messageText: '',
      disableButton: false,
      defaultOptionsClass: 'product__form-options',
      replacementBtnIsShown: window.theme.replacement_add_to_cart
        ? window.theme.replacement_add_to_cart.showReplacement
        : false,
      replacementBtnText: window.theme.replacement_add_to_cart
        ? window.theme.replacement_add_to_cart.replacementButtonText
        : '',
      replacementBtnLink: window.theme.replacement_add_to_cart
        ? window.theme.replacement_add_to_cart.replacementButtonLink
        : '',
      options: [],
    };

    this.updateOption = this.updateOption.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.updateImage = this.updateImage.bind(this);
    window.productForm = {
      global: this,
    };
  }

  static getDerivedStateFromProps(props, state) {
    // Set initial values for state based off of props received.
    if (state.selectedVariantId === 0) {
      const buttonText = props.initialVariant.available
        ? window.theme.strings.addToCart
        : window.theme.strings.soldOut;
      const messageText = props.initialVariant.available
        ? ''
        : window.theme.strings.contactUs
          .replace('Sold Out', '<del>Sold Out</del>')
          .replace('contact us', '<a target="_blank" href="/pages/contact-us">contact us</a>')
          .replace('local retailer', '<a target="_blank" href="/pages/stockists">local retailer</a>');
      const selectedVariantCombo = props.skuGroup[props.initialVariant.sku];
      const optionNames = props.options.map((option) => option.name);
      const selectedOptions = optionNames.map(
        (optionName) => selectedVariantCombo[optionName],
      );

      return {
        selectedVariantId: props.initialVariant.id,
        selectedVariantSKU: props.initialVariant.sku,
        selectedVariantImg: props.initialVariant.featured_image ? props.initialVariant.featured_image.src : '',
        selectedVariant: props.initialVariant,
        selectedOptions,
        disableButton: !props.initialVariant.available,
        buttonText,
        messageText,
        options: props.options,
      };
    }
    return null;
  }

  addToCart(evt) {
    if (evt) {
      evt.preventDefault();
    }
    if (this.props.isUpsell) {
      this.props.updateUpsellState(this.props.productId);
    }
    const {selectedVariantId} = this.state;
    window.sideCart.handleAddToCartEvent(evt, selectedVariantId, 1, true);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedVariantId === this.state.selectedVariantId) {
      return;
    }
    const selectedVariant = this.props.variants.find(
      (variant) => variant.id === this.state.selectedVariantId,
    );
    // We need to update the product page for variants so let's dispatch an event to handle that
    var variantChanged = new CustomEvent('variant:changed', {
      detail: selectedVariant,
    });
    // Listener for this event found in ../sections/product.js
    document.dispatchEvent(variantChanged);
    this.updateImage(this.state.selectedVariantId);
  }

  /**
   * Finds and updates the variant data in the react app.
   * @param {object} selected The selected key value pair from the RadioGroup component
   * @param {number} optionPosition The index of the option inside selectedOption and variant options arrays
   */
  updateOption(selected, optionPosition = 0) {
    const {variants, skuGroup} = this.props;
    const {selectedOptions, options} = this.state;

    if (selected) {
      selectedOptions[optionPosition] = selected;
    } else {
      selected = selectedOptions[0];

      // check when page loads if no variant is available for an option, and disable it
      options.forEach((option) => {
        option.values.forEach((value) => {
          const availableVariantsForOption = variants.filter((variant) => variant.options.some(item => item.includes(value.name.trim())) && variant.available);

          if (availableVariantsForOption.length === 0) {
            value.isDisabled = true;
          }
        });
      });
    }

    // finds all variants containing the selected option
    const availableVariants = variants.filter((variant) => variant.options.some(item => item.includes(selected)));

    if (availableVariants.length > 0) {
      // Get last option from the options array E.g. Size
      const lastOptionGroup = options[options.length - 1].values;
      const isFromLastOptionGroup = lastOptionGroup.some(item => item.name.includes(selected));

      if (!isFromLastOptionGroup) {
        // Filter variants that match the other selected options
        const otherSelectedOptions = selectedOptions.slice(0, selectedOptions.length - 1);

        const variantsMatch = availableVariants.filter((variant) => otherSelectedOptions.every(remainingOption => variant.options.some(item => item.includes(remainingOption))));

        // Set availability for each value based on selected values from the other option groups
        lastOptionGroup.forEach((value) => {
          const variantMatch = variantsMatch.find((variant) => variant.options.some(item => item.includes(value.name.trim())));
          if (variantMatch) {
            value.isDisabled = !variantMatch.available;
          }
        });
      }
    }

    const selectedVariant = variants.find((variant) => {
      let foundVariant = true;
      const {sku} = variant;

      const variantOptions = skuGroup[sku];
      if (!variantOptions) {
        return false;
      }
      const optionValues = Object.keys(variantOptions).map(
        (option) => variantOptions[option],
      );
      optionValues.forEach((option) => {
        const checkOption = selectedOptions.some(
          (selectedOption) => option === selectedOption,
        );
        if (!checkOption) {
          foundVariant = false;
        }
      });
      return foundVariant;
    });

    if (selectedVariant) {
      const buttonText = selectedVariant.available
        ? window.theme.strings.addToCart
        : window.theme.strings.soldOut;
      const messageText = selectedVariant.available
        ? ''
        : window.theme.strings.contactUs
          .replace('Sold Out', '<del>Sold Out</del>')
          .replace('contact us', '<a target="_blank" href="/pages/contact-us">contact us</a>')
          .replace('local retailer', '<a target="_blank" href="/pages/stockists">local retailer</a>');
      this.setState({
        selectedOptions,
        selectedVariantId: selectedVariant.id,
        selectedVariantSku: selectedVariant.sku,
        selectedVariant,
        disableButton: !selectedVariant.available,
        buttonText,
        messageText,
        options,
      });
    } else {
      this.setState({
        selectedOptions,
        disableButton: true,
        buttonText: window.theme.strings.unavailable,
        messageText: '',
        options,
      });
    }
  }

  updateImage(selectedVariant) {
    if (this.props.isUpsell) {
      const variantsArray = this.props.variants;
      const featuredImg = variantsArray.find(variant => variant.id === selectedVariant);
      if (featuredImg && featuredImg.featured_image) {
        this.setState({
          selectedVariantImg: featuredImg.featured_image.src,
        });
      }
    } else {
      const images = document.querySelectorAll('.product__image img');

      for (let i = 0; i < images.length; i++) {
        const allImgVariants = images[i].getAttribute('data-variants');
        if (
          allImgVariants.includes(selectedVariant) &&
          window.productImageSlider
        ) {
          window.productImageSlider.select(i);
        }
      }
    }
  }

  componentDidMount() {
    window.productForm.selectedVariantId = this.state.selectedVariantId;
    this.updateOption();
  }

  render() {
    const {initialVariant, variants, options} = this.props;
    const {
      selectedVariantId,
      selectedVariantSku,
      disableButton,
      buttonText,
      messageText,
      selectedOptions,
      defaultOptionsClass,
      replacementBtnIsShown,
      replacementBtnText,
      replacementBtnLink,
    } = this.state;
    return (
      <React.Fragment>
        {this.props.isUpsell && this.props.upsellAdded === false &&
          <div className="upsell-modal__product-wrapper">
            <img
              className="upsell-modal__product-img"
              ref={this.upsellProductImg}
              src={getSizedImageUrl(this.state.selectedVariantImg, '220x220_crop_center')}
              alt={this.props.initialVariant.name}
            />
            <h2 className="upsell-modal__product-title">{this.props.title}</h2>
          </div>
        }


        <form className={`product__form${this.props.upsellAdded ? ' upsell-form-added' : ''}`} method="post" action="/cart/add">
          <div className="product__form--inner">
          <input
            type="hidden"
            name="id"
            value={selectedVariantId ? selectedVariantId : initialVariant.id}
          />
          <input type="hidden" name="quantity" value="1" />
          {variants.length > 0 && (
            <div className={defaultOptionsClass}>
              <div className="product__form-options-group">
                {options.map((option, index) => {
                  return (
                    <RadioGroup
                      option={option}
                      key={index}
                      selectedValue={selectedOptions[index]}
                      position={index}
                      updateOption={this.updateOption}
                    />
                  );
                })}
              </div>
              {selectedVariantSku && selectedVariantSku !== '' && (
                <div className="product__form-sku">SKU: {selectedVariantSku}</div>
              )}
              <div className="btn-container">
                {replacementBtnIsShown ? (
                  <FindStockistLink
                    text={replacementBtnText}
                    link={replacementBtnLink}
                  />
                ) : (
                  <AddToCart
                    disabled={disableButton}
                    text={buttonText}
                    addToCart={this.addToCart}
                  />
                )}
                {messageText && <p className="product__sold-out-message">{parse(messageText)}</p>}
              </div>
            </div>
          )}
          </div>
          <div className="product__form--upsell-added">
            Added to cart
          </div>
        </form>
      </React.Fragment>
    );
  }
}

AddToCart.propTypes = {
  disabled: PropTypes.bool,
  text: PropTypes.string,
  addToCart: PropTypes.func,
};

FindStockistLink.propTypes = {
  isShown: PropTypes.bool,
  text: PropTypes.string,
  link: PropTypes.string,
};

RadioGroup.propTypes = {
  option: PropTypes.object,
  selectedValue: PropTypes.string,
  updateOption: PropTypes.func,
  position: PropTypes.number,
};

ProductForm.propTypes = {
  title: PropTypes.string,
  initialVariant: PropTypes.object.isRequired,
  variants: PropTypes.array,
  options: PropTypes.array,
  skuGroup: PropTypes.object,
  isUpsell: PropTypes.bool,
  upsellAdded: PropTypes.bool,
  productId: PropTypes.number,
  updateUpsellState: PropTypes.func,
};
